if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (this._zoomClickHandler) return;
        this._zoomClickHandler = (event) => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const image = event.target.closest('img.product-media__image');
          if (!image || !this.contains(image)) return;
          const media = image.closest('.product-media[data-media-id]');
          if (!media || media.dataset.mediaType !== 'image') return;
          const images = [...this.querySelectorAll('.product-media[data-media-id]')]
            .filter((node) => node.dataset.mediaType === 'image')
            .map((node) => ({ id: node.dataset.mediaId, image: node.querySelector('img.product-media__image') }))
            .filter((item) => item.image);
          const unique = [...new Map(images.map((item) => [item.id, item])).values()];
          const index = unique.findIndex((item) => item.id === media.dataset.mediaId);
          if (index < 0) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.openImageZoom(unique, index);
        };
        this.addEventListener('click', this._zoomClickHandler, true);
        this._expandButton = document.createElement('button');
        this._expandButton.type = 'button';
        this._expandButton.className = 'stars-expand-view';
        this._expandButton.innerHTML = `<svg viewBox="0 0 24 24" width="23" height="23" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 3H5a2 2 0 0 0-2 2v3M16 3h3a2 2 0 0 1 2 2v3M3 16v3a2 2 0 0 0 2 2h3M21 16v3a2 2 0 0 1-2 2h-3"/></svg><span>Click to open expanded view</span>`;
        this._expandButton.addEventListener('click', () => {
          const active = this.querySelector('.swiper-slide-active .product-media[data-media-type="image"] img.product-media__image')
            || this.querySelector('.product-media.active[data-media-type="image"] img.product-media__image')
            || this.querySelector('.product-media[data-media-type="image"] img.product-media__image');
          if (!active) return;
          const media = active.closest('.product-media[data-media-id]');
          const images = [...this.querySelectorAll('.product-media[data-media-type="image"][data-media-id]')]
            .map((node) => ({ id: node.dataset.mediaId, image: node.querySelector('img.product-media__image') }))
            .filter((item) => item.image);
          const unique = [...new Map(images.map((item) => [item.id, item])).values()];
          const index = unique.findIndex((item) => item.id === media.dataset.mediaId);
          if (index >= 0) this.openImageZoom(unique, index);
        });
        this.append(this._expandButton);
        if (!document.getElementById('stars-expand-view-style')) {
          const style = document.createElement('style');
          style.id = 'stars-expand-view-style';
          style.textContent = `media-gallery:has(> .stars-expand-view){position:relative;padding-bottom:76px!important;box-sizing:border-box}media-gallery > .stars-expand-view{position:absolute;left:50%;bottom:12px;transform:translateX(-50%);z-index:2;display:flex;align-items:center;justify-content:center;gap:10px;max-width:calc(100% - 20px);white-space:nowrap;margin:0;padding:10px 18px;background:#545454;color:#fff;border:0;border-radius:8px;font-family:inherit;font-size:18px;font-weight:500;line-height:1.3;cursor:pointer;text-align:center}media-gallery > .stars-expand-view:hover{background:#353535}media-gallery > .stars-expand-view:focus-visible{outline:3px solid #242424;outline-offset:3px}media-gallery > .stars-expand-view svg{flex:none}@media(max-width:749px){media-gallery:has(> .stars-expand-view){padding-bottom:62px!important}media-gallery > .stars-expand-view{font-size:14px;padding:9px 12px;bottom:10px}media-gallery > .stars-expand-view svg{width:18px;height:18px}}`;
          document.head.append(style);
        }
      }

      disconnectedCallback() {
        if (this._zoomClickHandler) this.removeEventListener('click', this._zoomClickHandler, true);
        this._zoomClickHandler = null;
        this._expandButton?.remove();
        this._expandButton = null;
        this.closeImageZoom();
      }

      openImageZoom(images, index) {
        this.closeImageZoom();
        const dialog = document.createElement('div');
        dialog.className = 'stars-image-zoom';
        dialog.setAttribute('role', 'dialog');
        dialog.setAttribute('aria-modal', 'true');
        dialog.setAttribute('aria-label', 'Product images');
        dialog.tabIndex = -1;
        dialog.innerHTML = `<button type="button" class="stars-image-zoom__close" aria-label="Close image">&times;</button>
          <button type="button" class="stars-image-zoom__prev" aria-label="Previous image">&#10094;</button>
          <img class="stars-image-zoom__image" alt="">
          <button type="button" class="stars-image-zoom__next" aria-label="Next image">&#10095;</button>
          <span class="stars-image-zoom__count visually-hidden" aria-live="polite"></span>`;
        if (!document.getElementById('stars-image-zoom-style')) {
          const style = document.createElement('style');
          style.id = 'stars-image-zoom-style';
          style.textContent = `media-gallery .product-media img.product-media__image{cursor:zoom-in}
            .stars-image-zoom{position:fixed;inset:0;z-index:2147483647;background:#fff;display:flex;align-items:center;justify-content:center;padding:64px 85px;box-sizing:border-box}
            .stars-image-zoom__image{display:block;max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain;user-select:none}
            .stars-image-zoom button{position:absolute;z-index:1;display:grid;place-items:center;background:transparent;color:#777;border:0;cursor:pointer;font:32px/1 Arial,sans-serif;width:54px;height:54px;padding:0}
            .stars-image-zoom button:hover{color:#222}.stars-image-zoom button:focus-visible{outline:2px solid #222;outline-offset:2px}
            .stars-image-zoom__close{right:25px;top:20px;color:#222!important;font-size:44px!important;font-weight:200!important}.stars-image-zoom__prev{left:28px;top:50%;transform:translateY(-50%)}.stars-image-zoom__next{right:28px;top:50%;transform:translateY(-50%)}
            .stars-image-zoom .visually-hidden{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}
            @media(max-width:749px){.stars-image-zoom{padding:55px 40px}.stars-image-zoom button{width:38px;height:38px;font-size:25px}.stars-image-zoom__close{right:8px;top:8px}.stars-image-zoom__prev{left:0}.stars-image-zoom__next{right:0}}`;
          document.head.append(style);
        }
        const previousFocus = document.activeElement;
        const previousOverflow = document.body.style.overflow;
        const previousHtmlOverflow = document.documentElement.style.overflow;
        const previousHtmlScrollbarWidth = document.documentElement.style.scrollbarWidth;
        const previousBodyScrollbarWidth = document.body.style.scrollbarWidth;
        const display = () => {
          const item = images[index];
          const src = item.image.getAttribute('data-max-resolution') || item.image.currentSrc || item.image.src;
          const zoomImage = dialog.querySelector('.stars-image-zoom__image');
          zoomImage.src = src;
          zoomImage.alt = item.image.alt || 'Product image';
          dialog.querySelector('.stars-image-zoom__count').textContent = `${index + 1} / ${images.length}`;
          dialog.querySelector('.stars-image-zoom__prev').hidden = images.length < 2;
          dialog.querySelector('.stars-image-zoom__next').hidden = images.length < 2;
        };
        const move = (step) => { index = (index + step + images.length) % images.length; display(); };
        const keydown = (event) => {
          if (event.key === 'Escape') this.closeImageZoom();
          if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
          if (event.key === 'Tab') {
            const controls = [...dialog.querySelectorAll('button:not([hidden])')];
            const current = controls.indexOf(document.activeElement);
            if (event.shiftKey && current <= 0) { event.preventDefault(); controls[controls.length - 1].focus(); }
            else if (!event.shiftKey && current === controls.length - 1) { event.preventDefault(); controls[0].focus(); }
          }
        };
        dialog.querySelector('.stars-image-zoom__close').addEventListener('click', () => this.closeImageZoom());
        dialog.querySelector('.stars-image-zoom__prev').addEventListener('click', () => move(-1));
        dialog.querySelector('.stars-image-zoom__next').addEventListener('click', () => move(1));
        dialog.addEventListener('click', (event) => { if (event.target === dialog) this.closeImageZoom(); });
        let touchX = null;
        dialog.addEventListener('touchstart', (event) => { touchX = event.changedTouches[0].screenX; }, { passive: true });
        dialog.addEventListener('touchend', (event) => {
          if (touchX === null) return;
          const delta = event.changedTouches[0].screenX - touchX;
          if (Math.abs(delta) > 45) move(delta < 0 ? 1 : -1);
          touchX = null;
        }, { passive: true });
        this._zoomCleanup = () => {
          document.removeEventListener('keydown', keydown);
          dialog.remove();
          document.body.style.overflow = previousOverflow;
          document.documentElement.style.overflow = previousHtmlOverflow;
          document.documentElement.style.scrollbarWidth = previousHtmlScrollbarWidth;
          document.body.style.scrollbarWidth = previousBodyScrollbarWidth;
          if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
          this._zoomCleanup = null;
        };
        document.body.append(dialog);
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.style.scrollbarWidth = 'none';
        document.body.style.scrollbarWidth = 'none';
        document.addEventListener('keydown', keydown);
        display();
        dialog.querySelector('.stars-image-zoom__close').focus();
      }

      closeImageZoom() {
        if (this._zoomCleanup) this._zoomCleanup();
      }

      setActiveMedia(mediaId, smooth = false) {
        if (!mediaId) return false;

        let cleanMediaId = mediaId;
        if (mediaId.indexOf('-') !== -1) {
          const parts = mediaId.split('-');
          cleanMediaId = parts[parts.length - 1];
        }

        let element = this.querySelector(`[data-media-id="${cleanMediaId}"]`);
        
        if (!element) {
          element = this.querySelector(`[data-media-id="${mediaId}"]`);
        }

        if (!element) return false;

        this.querySelectorAll('[data-media-id].active').forEach((node) => node.classList.remove('active'));

        element.classList.add('active');

        const allMediaElements = Array.from(this.querySelectorAll('[data-media-id]'));
        const mediaIndex = allMediaElements.indexOf(element);

        this.syncSlideshow(element, mediaIndex, smooth);
        this.syncThumbnails(element, mediaIndex);

        if (this.classList.contains('media-gallery--grid')) {
          this.swapGridMedia(element, mediaIndex);
        }

        return true;
      }

      /**
       * Sync slideshow/swiper component when media is activated
       * @param {HTMLElement} mediaElement - The active media element
       * @param {number} mediaIndex - The index of the media in the gallery
       * @param {boolean} smooth - Whether to use smooth transition
       */
      syncSlideshow(mediaElement, mediaIndex, smooth = false) {
        try {
          if (!this.classList.contains('media-gallery--carousel')) return;

          const swiperComponent = this.querySelector('swiper-component');
          if (!swiperComponent) return;
          
          const waitForSwiper = (retries = 10) => {
            if (swiperComponent.initSwiper) {
              const slides = Array.from(swiperComponent.querySelectorAll('.swiper-wrapper .swiper-slide'));
              let slideIndex = mediaIndex;
              const slideElement = mediaElement.closest('.swiper-slide');
              if (slideElement) {
                const foundIndex = slides.indexOf(slideElement);
                if (foundIndex >= 0) {
                  slideIndex = foundIndex;
                }
              }

              if (slideIndex >= 0 && slideIndex < slides.length && swiperComponent.initSwiper) {
                swiperComponent.initSwiper.slideTo(slideIndex, smooth ? 800 : 0);
              }
            } else if (retries > 0) {
              setTimeout(() => waitForSwiper(retries - 1), 50);
            }
          };

          waitForSwiper();
        } catch (e) {
          try {
            if (this.slideshow && typeof this.slideshow.goTo === 'function') {
              this.slideshow.goTo(mediaIndex);
            }
          } catch (err) {
            // silent
          }
        }
      }

      /**
       * Sync thumbnails controls when media is activated
       * @param {HTMLElement} mediaElement - The active media element
       * @param {number} mediaIndex - The index of the media in the gallery
       */
      syncThumbnails(mediaElement, mediaIndex) {
        try {
          const thumbnailsContainer = this.querySelector('.swiper-controls__thumbnails-container');
          if (!thumbnailsContainer) return;

          const thumbnailButtons = Array.from(thumbnailsContainer.querySelectorAll('.swiper-controls__thumbnail[data-index]'));
          if (thumbnailButtons.length === 0) return;

          let slideIndex = mediaIndex;
          
          if (this.classList.contains('media-gallery--carousel')) {
            const swiperComponent = this.querySelector('swiper-component');
            if (swiperComponent) {
              const slideElement = mediaElement.closest('.swiper-slide');
              if (slideElement) {
                const slides = Array.from(swiperComponent.querySelectorAll('.swiper-wrapper .swiper-slide'));
                const foundIndex = slides.indexOf(slideElement);
                if (foundIndex >= 0) {
                  slideIndex = foundIndex;
                }
              } else {
                if (swiperComponent.initSwiper && typeof swiperComponent.initSwiper.activeIndex === 'number') {
                  slideIndex = mediaIndex;
                }
              }
            }
          }

          let targetThumbnail = thumbnailButtons.find((button) => {
            const index = parseInt(button.getAttribute('data-index'), 10);
            return !isNaN(index) && index === slideIndex;
          });

          if (!targetThumbnail) {
            targetThumbnail = thumbnailButtons.find((button) => {
              const index = parseInt(button.getAttribute('data-index'), 10);
              return !isNaN(index) && index === mediaIndex;
            });
          }

          if (targetThumbnail) {
            const finalSlideIndex = parseInt(targetThumbnail.getAttribute('data-index'), 10);

            this.syncThumbnailSwiper(thumbnailsContainer, thumbnailButtons, targetThumbnail, finalSlideIndex);
          }
        } catch (e) {
          // silent
        }
      }

      /**
       * Sync thumbnail swiper to show the active thumbnail
       * @param {HTMLElement} thumbnailsContainer - The thumbnail container element
       * @param {Array} thumbnailButtons - Array of all thumbnail buttons
       * @param {HTMLElement} targetThumbnail - The active thumbnail button
       * @param {number} slideIndex - The slide index to sync to
       */
      syncThumbnailSwiper(thumbnailsContainer, thumbnailButtons, targetThumbnail, slideIndex) {
        try {
          const waitForThumbnailSwiper = (retries = 10) => {
            const swiperComponent = this.querySelector('swiper-component');
            let thumbsSwiper = null;

            if (swiperComponent && swiperComponent.initSwiper && swiperComponent.initSwiper.params && swiperComponent.initSwiper.params.thumbs) {
              thumbsSwiper = swiperComponent.initSwiper.params.thumbs.swiper;
            }

            if (!thumbsSwiper) {
              const thumbnailSwiper = thumbnailsContainer.querySelector('.swiper');
              if (thumbnailSwiper && thumbnailSwiper.swiper) {
                thumbsSwiper = thumbnailSwiper.swiper;
              }
            }

            if (thumbsSwiper) {
              if (slideIndex >= 0 && slideIndex < thumbnailButtons.length) {
                thumbsSwiper.slideTo(slideIndex, 300);
              }
            } else if (retries > 0) {
              setTimeout(() => waitForThumbnailSwiper(retries - 1), 50);
            }
          };

          waitForThumbnailSwiper();
        } catch (e) {
          // silent
        }
      }

      /**
       * Swap media in grid layout: move variant image to first position
       * @param {HTMLElement} mediaElement - The active media element
       * @param {number} mediaIndex - The index of the media in the gallery
       */
      swapGridMedia() {
        try {
          if (typeof MainEvents !== 'undefined' && MainEvents.variantUpdate) {
            const handleVariantUpdateOnce = (event) => {
              try {
                const source = event?.detail?.data?.html;
                if (!source) return;

                const newMediaGallery = source.querySelector('media-gallery');
                if (!newMediaGallery) return;
                this.replaceWith(newMediaGallery);

                try {
                  newMediaGallery.scrollIntoView({ behavior: 'smooth' });
                } catch (e) {
                  // ignore scrolling errors
                }
              } catch (e) {
                // silent
              } finally {
                document.removeEventListener(MainEvents.variantUpdate, handleVariantUpdateOnce);
              }
            };
            document.addEventListener(MainEvents.variantUpdate, handleVariantUpdateOnce);
          }
          
        } catch (e) {
          // silent
        }
      }
    }
  );
}
